import angular from 'angular';
import { AJS_MODULE_NAME } from '@common/constants';
import { downgradeComponent } from '@angular/upgrade/static';
import { ImportPcardComponent } from '@app/modules/fund-management/accounts-payable/import-pcard/components/import-pcard/import-pcard.component';
import { SalesTaxInvoiceParamsComponent } from '@app/modules/fund-management/accounts-payable/sales-tax-invoice-params/sales-tax-invoice-params.component';
import { UserListControlComponent } from '@app/modules/fund-management/account-user/user-list-control.component';
import { ImportClearedChecksComponent } from '@app/modules/fund-management/cash-management/bank-recon/import-cleared-checks/import-cleared-checks.component';
import { ApprovalLevelComponent } from '@app/modules/system-settings/system-setup/approval-setup/approval-level/approval-level.component';
import { ClearedCheckLayoutComponent } from '@app/modules/system-settings/system-setup/banking-info/cleared-check-layout/cleared-check-layout.component';
import {
	ApprovalHistoryComponent,
	ChangeHistoryButtonComponent,
	DocManagementComponent,
	LocalUseDataEntryComponent,
	NotesComponent,
	UnitListItemsSetupComponent,
	AjsFaIconTooltipComponent,
	AjsCancelPrintChecksSessionButtonComponent,
} from '@app/shared/components';
import { FormComponent } from '@app/shared/forms/components/form.component';
import { LinqSocketsProgressComponent, LinqSocketsNotificationsComponent } from '@app/shared/sockets/components';
import { DesignComponent } from '@app/shared/layout/design/design.component';
import { SetupBudgetImportComponent } from '@app/modules/fund-management/manage-accounts';
import { RelatedVendorsComponent } from '@app/modules/fund-management/accounts-payable/vendors/components/related-vendors/related-vendors.component';

angular
	.module(AJS_MODULE_NAME)
	.directive(
		'appDesign',
		downgradeComponent({
			component: DesignComponent,
		}),
	)
	.directive(
		'fmCashManagementImportClearedChecks',
		downgradeComponent({
			component: ImportClearedChecksComponent,
		}),
	)
	.directive(
		'fmPayableRelatedVendors',
		downgradeComponent({
			component: RelatedVendorsComponent,
		}),
	)
	.directive(
		'fmUserListControl',
		downgradeComponent({
			component: UserListControlComponent,
		}),
	)
	.directive(
		'linqSocketsNotifications',
		downgradeComponent({
			component: LinqSocketsNotificationsComponent,
		}),
	)
	.directive(
		'linqSocketsProgress',
		downgradeComponent({
			component: LinqSocketsProgressComponent,
		}),
	)
	.directive(
		'localUseDataEntry',
		downgradeComponent({
			component: LocalUseDataEntryComponent,
		}),
	)
	.directive(
		'slApprovalHistory',
		downgradeComponent({
			component: ApprovalHistoryComponent,
		}),
	)
	.directive(
		'slChangeHistoryButton',
		downgradeComponent({
			component: ChangeHistoryButtonComponent,
		}),
	)
	.directive(
		'slFormComponent',
		downgradeComponent({
			component: FormComponent,
		}),
	)
	.directive(
		'slNotes',
		downgradeComponent({
			component: NotesComponent,
		}),
	)
	.directive(
		'slDocManagement',
		downgradeComponent({
			component: DocManagementComponent,
		}),
	)
	.directive(
		'slImportPcard',
		downgradeComponent({
			component: ImportPcardComponent,
		}),
	)
	.directive(
		'slSalesTaxInvoiceParams',
		downgradeComponent({
			component: SalesTaxInvoiceParamsComponent,
		}),
	)
	.directive(
		'slUnitListItemsSetup',
		downgradeComponent({
			component: UnitListItemsSetupComponent,
		}),
	)
	.directive(
		'ssApprovalLevels',
		downgradeComponent({
			component: ApprovalLevelComponent,
		}),
	)
	.directive(
		'ssSystemSetupClearedCheckLayout',
		downgradeComponent({
			component: ClearedCheckLayoutComponent,
			outputs: ['dataChanged'],
		}),
	)
	.directive(
		'ajsCancelPrintChecksSessionButton',
		downgradeComponent({
			component: AjsCancelPrintChecksSessionButtonComponent,
		}),
	)
	.directive(
		'ajsFaIconTooltip',
		downgradeComponent({
			component: AjsFaIconTooltipComponent,
		}),
	)
	.directive(
		'fmSetupBudgetImport',
		downgradeComponent({
			component: SetupBudgetImportComponent,
		}),
	);
